import store from '../store/store';
import { mutatorAction } from 'satcheljs';
export default mutatorAction('setDomainState', function setDomainState(response) {
    if (response.domainData) {
        store.isValid = response.domainData.isDomainValidated;
        store.domainName = response.domainData.domainName;
        store.isDomainCreated = true;
        store.domainPurchaseDate = new Date(response.domainData.domainPurchaseDate);
    }
    else {
        store.isDomainCreated = false;
    }
});
//# sourceMappingURL=setDomainState.js.map